"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.program = exports.telemetry = exports.clock = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const neorhythm_mapping_1 = require("../lib/neorhythm-mapping");
const neorhythm_parsers_1 = require("../lib/neorhythm-parsers");
function clock(emitter) {
    const stop = rxjs_1.fromEvent(emitter, 'stop');
    const update = rxjs_1.fromEvent(emitter, 'update');
    // TODO: fix timer: doesn't update correctly with counter 'update'
    const timer = update.pipe(operators_1.switchMap(() => rxjs_1.interval(1000)));
    const $clock = rxjs_1.combineLatest([update, timer])
        .pipe(operators_1.map(([counter, timer]) => counter + timer), operators_1.takeUntil(stop))
        .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
    $clock.connect();
    return $clock;
}
exports.clock = clock;
function telemetry(device) {
    // NeoRhythm doesn't notify on telemetry data – read every 5 sec
    return rxjs_1.interval(4500).pipe(operators_1.map(async () => {
        const system = await neorhythm_parsers_1.readSystemSettings(device.deviceId);
        return { batteryLevel: system === null || system === void 0 ? void 0 : system.batteryLevel };
    }));
}
exports.telemetry = telemetry;
function program(device) {
    return rxjs_1.interval(4000).pipe(operators_1.map(async () => {
        const program = await neorhythm_parsers_1.readActiveProgram(device.deviceId);
        if (!program)
            return;
        return neorhythm_mapping_1.neoRhythmToStandard(program);
    }));
}
exports.program = program;
//# sourceMappingURL=neorhythm.js.map